import { Button, Divider, Input } from "@mui/material";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import ReactLoading from "react-loading";
import { MetaTags } from "react-meta-tags";
import LayoutOne from "../../layouts/LayoutOne";
import HomeBanner from "../../pages/home/HomeBanner";
import PageBuilder from "./PageBuilder";
import YouTubeBackground from "./YouTubeBackground";
import { Height } from "@mui/icons-material";

const PersonalizzaHomepage = () => {
  const [inSalvataggio, setInSalvataggio] = useState(false);

  return (
    <>
      <Fragment>
        <MetaTags>
          <title>DGA Planet Shirt SRL | Personalizza Home</title>
          <meta name="description" content="powered by Pegaso Gest Team" />
        </MetaTags>

        <LayoutOne headerTop="invisible" footerTop="invisible">
          <div>
            <div>
              <div>
                <PageBuilder />
              </div>
              {/*<YouTubeBackground videoId="vB5clt5Bxzg" widthPercent={20} />*/}
            </div>
          </div>
        </LayoutOne>
      </Fragment>
    </>
  );
};
export default PersonalizzaHomepage;
